import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 600px;

  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px 24px;
    border-bottom: 1px solid #e5e7eb;

    .titleHeader {
      font-size: 18px;
      font-weight: 600;
      color: #324150;
    }

    .iconHeader {
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 24px;
      height: 24px;

      &:hover {
        opacity: 0.7;
      }
    }
  }
`;

export const Content = styled.div`
  display: flex;
  flex: 1;
  overflow: hidden;
`;

export const LeftContent = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 24px;
  border-right: 1px solid #e5e7eb;
`;

export const RightContent = styled.div`
  width: 340px;
  overflow-y: auto;
  background: #f9fafb;
`;

export const VerticalHr = styled.div`
  width: 1px;
  background: #e5e7eb;
`;

export const FooterHr = styled.div`
  height: 1px;
  background: #e5e7eb;
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 16px 24px;
  border-top: 1px solid #e5e7eb;

  .buttonCancel {
    min-width: 100px;
  }

  .buttonSubmit {
    min-width: 120px;
  }
`;
